import { render, staticRenderFns } from "./defaultModel.vue?vue&type=template&id=4bbc0a5e&scoped=true&"
import script from "./defaultModel.vue?vue&type=script&lang=js&"
export * from "./defaultModel.vue?vue&type=script&lang=js&"
import style0 from "./defaultModel.vue?vue&type=style&index=0&id=4bbc0a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbc0a5e",
  null
  
)

component.options.__file = "defaultModel.vue"
export default component.exports